export default __webpack_public_path__ + "static/couraca-aa71d806da8fb25144f69ebc8b6eeccc.webp";